module.exports = __webpack_public_path__ + "static/media/logo-arte.87d3762a.svg";